export const styles = {
  container: "flex flex-col",
  input: "mr-2",
  label: "",
  item_container: "py-2",
};

export type HyamRadioGroupStyles = typeof styles;
